import { getIconProps, type IconProps } from '#types'

/**
 * Checkout icon — checkmark inside a rotating circle (sketch-style).
 *
 * Used for the final confirmation step in booking/checkout flows and any
 * surface representing "validated / complete".
 *
 * @example
 * ```tsx
 * <CheckoutIcon className="h-6 w-6" />
 * ```
 */
export function CheckoutIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M16.0909 9.54545L10.8275 15.1143C10.6278 15.3255 10.304 15.3255 10.1043 15.1143L7.90909 12.7917M7.5 19.796C6.27242 19.0858 5.22814 18.0941 4.45549 16.9091M7.5 4.20404C6.27242 4.91416 5.22814 5.90589 4.45549 7.09091M3.23346 14.0455C3.08074 13.3883 3 12.7036 3 12C3 11.2964 3.08074 10.6117 3.23346 9.95455M10.3636 3.1484C10.8943 3.05093 11.4412 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.4412 21 10.8943 20.9491 10.3636 20.8516"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
